module.exports = __webpack_public_path__ + "e0e6e1007fe90b4bff3e08eae99fb2eb.svg";